export default "__VITE_ASSET__C5RY_R0g__"